<template>
  <div>
    {{ $t('message_sent') }}
    <div v-for="property of properties" :key="property">
      <div
        v-if="commentData[property]"
        class="d-inline-flex cursor-pointer align-center"
        @click="views[property] = !views[property]"
      >
        <VIcon small color="grey">
          {{ views[property] ? emailOpenIcon : emailIcon }}
        </VIcon>
        <div class="caption ml-1 primary--text pseudo-link">
          {{ $t(property) }}
        </div>
        <VIcon small color="primary">
          {{ views[property] ? menuUpIcon : menuDownIcon }}
        </VIcon>
      </div>
      <div v-if="views[property]" class="my-1">
        <div v-html="formatCommentData(commentData[property])" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  mdiEmailOpen,
  mdiEmail,
  mdiMenuUp,
  mdiMenuDown,
} from '@mdi/js';

export default {
  name: 'CandidateLogMessageSendBlock',
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      emailOpenIcon: mdiEmailOpen,
      emailIcon: mdiEmail,
      menuUpIcon: mdiMenuUp,
      menuDownIcon: mdiMenuDown,
      properties: ['mail', 'sms'],
      views: {
        mail: false,
        sms: false,
      },
    };
  },
  computed: {
    commentData() {
      return JSON.parse(this.message.comment);
    },
  },
  methods: {
    formatCommentData(text) {
      return text.replace(/\n/g, '<br>');
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  message_sent: Message sent
  mail: E-mail
  sms: Text message
</i18n>

<i18n locale="ru" lang="yaml">
  message_sent: Отправлено сообщение
  mail: E-mail
  sms: SMS
</i18n>
